import { setRegisteredData } from "./registered-data";

$('.contact-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');
    
    // setRegisteredData(data, 'section#contact');

    // page swap
    // $('section#contact .page').addClass('d-none');
    // $('section#contact .page-thank-you').removeClass('d-none').css('display', 'block');

    // modal — same scheme as lech-lap-film
    $('#modal-form-contact').modal('show');
});